import { render, staticRenderFns } from "./StopServiceFatalError.vue?vue&type=template&id=6a23fbae&scoped=true&"
import script from "./StopServiceFatalError.vue?vue&type=script&lang=js&"
export * from "./StopServiceFatalError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23fbae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a23fbae')) {
      api.createRecord('6a23fbae', component.options)
    } else {
      api.reload('6a23fbae', component.options)
    }
    module.hot.accept("./StopServiceFatalError.vue?vue&type=template&id=6a23fbae&scoped=true&", function () {
      api.rerender('6a23fbae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/stopservice/StopServiceFatalError.vue"
export default component.exports